import axios from 'common/requester';
import { LINB_API } from 'common/constants/api-urls';
import _ from 'lodash';

export const formatIssueTypes = (issueTypes = []) => {
  return issueTypes.map(issueType => {
    const { iconUrl, subtask, level } = issueType.extra;
    return {
      iconUrl,
      id: issueType.entity_id,
      name: issueType.value,
      subtask,
      level
    };
  });
};

export const getIssueTypes = async ({ searchQuery = '' } = {}) => {
  const url = LINB_API.PM_SERVICE.PM_ENTITIES.ISSUE_TYPES;
  const { items } = await axios.get(`${url}?keyword=${searchQuery}`);
  const formattedIssueTypes = formatIssueTypes(_.uniqBy(items, 'value'));
  return { items: formattedIssueTypes };
};
